import React, { useEffect, useState } from "react";
import { Button } from "./ui";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../services";
import { useTranslation } from "react-i18next";
import { translateAuthApiMessage } from "../utils/translateAuthApiMessage";
import AuthPageLayout, { AuthSuccessIcon } from "./AuthPageLayout";

function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation("translation");
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function verify() {
      if (!token) {
        setStatus("error");
        setMessage(
          t("verifyEmail.invalidLink", { defaultValue: "Invalid verification link." })
        );
        return;
      }
      try {
        const res = await api.post(`/verify-email/${token}`);
        if (cancelled) return;
        setStatus("success");
        setMessage(
          translateAuthApiMessage(res.data?.message, t) ||
            t("verifyEmail.success", {
              defaultValue: "Email verified successfully. You can now log in.",
            })
        );
      } catch (err) {
        if (cancelled) return;
        setStatus("error");
        setMessage(
          translateAuthApiMessage(err.response?.data?.message, t) ||
            t("verifyEmail.failed", {
              defaultValue: "Invalid or expired verification link.",
            })
        );
      }
    }

    verify();
    return () => {
      cancelled = true;
    };
  }, [token, t]);

  return (
    <AuthPageLayout cardClassName="auth-page-card--status">
      <div className="auth-status-body">
        {status === "loading" && (
          <>
            <div className="auth-spinner" aria-hidden />
            <p>
              {t("verifyEmail.verifying", { defaultValue: "Verifying your email…" })}
            </p>
          </>
        )}

        {status === "success" && (
          <>
            <AuthSuccessIcon />
            <h1 className="auth-page-card__title">
              {t("verifyEmail.titleSuccess", { defaultValue: "Email Verified!" })}
            </h1>
            <p>{message}</p>
          </>
        )}

        {status === "error" && (
          <>
            <div className="auth-status-icon auth-status-icon--error" aria-hidden>
              !
            </div>
            <h1 className="auth-page-card__title">
              {t("verifyEmail.titleError", { defaultValue: "Verification Failed" })}
            </h1>
            <p>{message}</p>
          </>
        )}
      </div>

      {status !== "loading" ? (
        <Button
          color="primary"
          size="md"
          className="auth-submit"
          onClick={() => navigate("/")}
        >
          {t("verifyEmail.backToLogin", { defaultValue: "BACK TO LOGIN" })}
        </Button>
      ) : null}
    </AuthPageLayout>
  );
}

export default VerifyEmail;
